import React from 'react'
import Loader from 'react-loader-spinner'
import { checkTranslation, translate } from '../utils/useful'

class Pagination extends React.Component {
    state = {
        key: ''
    }

    render() {
        // if (this.props.totalCount) {
        let totalCount = this.props.totalCount ?? 0
        let pages = Math.ceil(totalCount / this.props.limit)

        let array = []
        for (let i = 0; i < pages; i++) {
            array.push(i + 1)
        }

        let dotDone = false

        return (
            <div>
                {pages > 1 && (
                    <>
                        <div className="flexcc w-100" style={{ flexDirection: 'revert', overflow: 'auto', backgroundColor: this.props.floatMode ? '#fff' : '', boxShadow: this.props.floatMode ? '0px 0px 10px #10101010':'' }}>
                            {array.map((prop, index) => {
                                if (index == 0 || index == array.length - 1 || (index > this.props.currentPage - 2 && index < this.props.currentPage + 3)) {
                                    dotDone = false

                                    return (
                                        <p key={index} onClick={() => this.props.changePage(index)} style={{ margin: 2, background: this.props.currentPage == index ? this.props.colors ? this.props.colors.background : "#677dc4" : '#d2d8e299', color: this.props.currentPage == index ? this.props.colors ? this.props.colors.textColor : "#fff" : '#789', borderRadius: 2, padding: '2px 10px', cursor: 'pointer' }}>{checkTranslation(prop)}</p>
                                    )

                                } else {
                                    if (!dotDone) {
                                        dotDone = true
                                        return (
                                            <p key={index} style={{ margin: 2, borderRadius: 2, padding: '2px 6px', }}>...</p>
                                        )
                                    }
                                }
                            })}

                        </div>
                        {!this.props.hideInput && (
                            <div className="flexcc mt-1">
                                <input ref={el => this.input = el} className="mrd-1" style={{ height: 35, border: '1px solid #eee', borderRadius: 4, width: 80, padding: '4px 6px' }} placeholder={translate("Page")} />
                                <button onClick={() => this.props.changePage(Number(this.input.value) - 1)} className="mld-1" style={{ height: 35, background: this.props.colors ? this.props.colors.background : '#677dc4', borderRadius: 4, padding: '5px 15px', color: this.props.colors ? this.props.colors.textColor : '#fff' }}>{translate('Go')}</button>
                            </div>
                        )}
                    </>
                )}
            </div>
        )
        // }
        // }
    }
}

export default (Pagination);